import { useState } from "react";
import { Link } from "react-router-dom";
import IMAGES from "../../assets";
import { API, Notify } from "../../utils";
import { MdEmail, MdArrowBack, MdCheckCircle } from "react-icons/md";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const forgotPasswordHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
 
    if (!email) {
      setIsLoading(false);
      return Notify("Please Fill all the Fields", "warn");
    }

    try {
      const response = await API.post("/api/auth/forgotPassword", { email });
      const data = response.data;

      if (data.success) {
        setIsLoading(false);
        setIsEmailSent(true);
        return Notify(data.data, "success");
      } else {
        setIsLoading(false);
        return Notify(data.error, "error");
      }
    } catch (error) {
      setIsLoading(false);
      const errorMsg = error.response?.data?.error || "Internal server error";
      return Notify(errorMsg, "error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 p-6 text-center">
      <div className="w-full max-w-[450px] bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-500">
        {isEmailSent ? (
          <div className="p-10 space-y-6">
            <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <MdCheckCircle className="w-12 h-12 text-green-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Check your mail</h1>
            <p className="text-gray-500 leading-relaxed">
              We have sent password recovery instructions to <span className="font-bold text-gray-700">{email}</span>.
            </p>
            <Link to="/login" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl transition-all active:scale-95 shadow-lg shadow-blue-100">
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            <div className="bg-blue-600 p-8 text-white relative">
              <Link to="/login" className="absolute top-6 left-6 text-blue-200 hover:text-white transition-colors">
                <MdArrowBack className="w-6 h-6" />
              </Link>
              <h1 className="text-2xl font-bold tracking-tight">Reset Password</h1>
              <p className="text-blue-100 text-sm mt-1 px-4">Enter your email to receive recovery instructions</p>
            </div>

            <form onSubmit={forgotPasswordHandler} className="p-8 space-y-6">
              <div className="text-left">
                <label className="text-[11px] font-bold text-gray-400 uppercase tracking-wider block mb-1.5 ml-1">Email Address</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none transition-colors group-focus-within:text-blue-600 text-gray-400">
                    <MdEmail className="w-5 h-5" />
                  </div>
                  <input
                    type="email"
                    required
                    className="w-full pl-11 pr-4 py-3 bg-gray-50 border border-gray-100 rounded-xl outline-none focus:border-blue-500 focus:bg-white transition-all text-gray-700 text-sm"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-95 disabled:opacity-70 disabled:active:scale-100"
              >
                {isLoading ? (
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin mx-auto"></div>
                ) : (
                  "Send Instructions"
                )}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
